// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { getLinkForStreamingProjectsSPPage } from '@streaming-projects/links';
import { useDeleteStreamGovernanceWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPStreamGovernanceWorkloadDeleteWarningModal = ({
  isOpen,
  onClose,
  streamGovernanceWorkloadId = null,
  streamGovernanceWorkloadName = null,
  streamGovernanceWorkloadResourceId = null,
  spVersion,
}) => {
  const [deleteWorkload] = useDeleteStreamGovernanceWorkloadMutation();
  const { orgId, spId } = useParams();
  const { push } = useHistory();
  const header = `Delete Stream Governance Workload ${streamGovernanceWorkloadName}`;
  const headerBody = <p>Are you sure you want to delete this Stream Governance Workload?</p>;

  const onClickHandlerForOK = async () => {
    const { error } = await deleteWorkload({
      orgId,
      spId,
      streamGovernanceWorkloadId,
      payload: {
        stream_governance_resource_id: streamGovernanceWorkloadResourceId,
        sp_version: spVersion,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Stream Governance Workload delete was successful!');
      push(getLinkForStreamingProjectsSPPage(orgId, spId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
